import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  actionCityList,
  actionCountryList,
  actionStateList,
} from "../../services/CommonService";
import {
  createClientProfile,
  deleteClientProfile,
  exportClientProfile,
  getClientProfileList,
  importClientProfile,
  updateClientProfile,
} from "../../services/ClientProfileServices";
import * as XLSX from "xlsx";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";

const ClientProfile = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const location = useLocation();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [clientProfileListe, setClientProfileList] = useState([]);

  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [clientProfileData, setclientProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
  });

  let errorsObj = {
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: "",
    is_vat_exempt: "",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [modifyImportModal, setModifyImportModal] = useState(false);
  const [file, setFile] = useState(null);
  let errorsObjImport = {
    file: "",
  };
  const [errorsImport, setErrorsImport] = useState(errorsObjImport);

  const handleImportModal = () => {
    setModifyImportModal(true);
  };

  const handleImportCloseModal = () => {
    setModifyImportModal(false);
    setErrorsImport("");
    setFile(null);
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleAddressChange = (index, value) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses[index] = value;
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: [...clientProfileData.shipping_addresses, ""],
    });
  };

  const handleRemoveAddress = (index) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses.splice(index, 1);
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleCheckboxChange = (e) => {
    setclientProfileData({
      ...clientProfileData,
      is_vat_exempt: e.target.checked ? 1 : 0,
    });
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
    setErrors({
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
    });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    setParams(paramsObj);
  };

  useEffect(function () {
    actionCountryList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setCountryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (clientProfileData?.country_id) {
      actionStateList({ country_id: clientProfileData?.country_id })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setStateList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  useEffect(() => {
    if (clientProfileData?.district) {
      actionCityList({ state_id: clientProfileData?.district })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setCityList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  const fetchClientProfileData = () => {
    let data = { ...params };
    getClientProfileList(data)
      .then((response) => {
        setClientProfileList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchClientProfileData(data);
    },
    [params]
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onEditPartGroup = (e, item) => {
    setModifyModal(true);
    setclientProfileData({
      uuid: item?.uuid,
      id: item?.id,
      name: item?.name,
      country_code: item?.country_code,
      country_id: item?.country_id,
      district: item?.district,
      city: item?.city,
      bill_address: item?.bill_address,
      postal_code: item?.postal_code,
      shipping_addresses: item?.shipping_addresses,
      vat_country_code: item?.vat_country_code,
      vat_number: item?.vat_number,
      vat_percentage: item?.vat_percentage,
      is_vat_exempt: item?.is_vat_exempt,
      indicative_phone_code: item?.indicative_phone_code,
      phone_number: item?.phone_number,
      whatsapp_number: item?.whatsapp_number,
      email: item?.email,
    });
    setErrors({
      name: "",
      country_code: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deleteClientProfile(data)
      .then((response) => {
        let data = { ...params };

        fetchClientProfileData(data);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleWarehoueEntity = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!clientProfileData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!clientProfileData.country_code) {
      errorObj.country_code = `Country is required.`;
      error = true;
    }

    if (!clientProfileData.district) {
      errorObj.district = `State is required.`;
      error = true;
    }

    if (!clientProfileData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!clientProfileData.bill_address) {
      errorObj.bill_address = `Bill address is required.`;
      error = true;
    }

    if (!clientProfileData.postal_code) {
      errorObj.postal_code = `Postal code is required.`;
      error = true;
    }

    if (!clientProfileData.email) {
      errorObj.email = `Email is required.`;
      error = true;
    }

    // if (!/^\d{3}$/.test(clientProfileData.indicative_phone_code)) {
    //   errorObj.indicative_phone_code = `Indicative phone code must be exactly 3 digits.`;
    //   error = true;
    // }

    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    setIsModifyButtonLoad(true);
    let data = {
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      country_id: clientProfileData?.country_id,
      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: clientProfileData?.vat_percentage,
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
    };

    let updateData = {
      uuid: clientProfileData?.uuid,
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      country_id: clientProfileData?.country_id,

      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: parseFloat(clientProfileData.vat_percentage),
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
    };

    if (clientProfileData?.uuid) {
      updateClientProfile(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchClientProfileData(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setclientProfileData({
            uuid: "",
            id: "",
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
          setErrors({
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createClientProfile(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchClientProfileData(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);

          setclientProfileData({
            uuid: "",
            id: "",
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
          setErrors({
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  const handleImportGroup = (e) => {
    e.preventDefault();

    let error = false;
    let errorObjImport = { ...errorsObjImport };
    if (!file) {
      errorObjImport.file = `File is required.`;
      error = true;
    }

    setErrorsImport(errorObjImport);
    if (error) return;

    setIsModifyButtonLoad(true);
    const formData = new FormData();
    formData.append("files", file);

    importClientProfile(formData)
      .then((response) => {
        toast.success(response.data.message);
        let data = { ...params };
        fetchClientProfileData(data);
        setModifyImportModal(false);
        setIsModifyButtonLoad(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const fetchExportClientProfile = () => {
    let data = { ...params };
    exportClientProfile(data)
      .then((response) => {
        const worksheet = XLSX.utils.json_to_sheet(response.data.data);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "ClientProfile.csv");
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleExport = () => {
    let data = { ...params };
    fetchExportClientProfile(data);
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Group</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left fuelCT"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder={t("search")}
                      ></input>
                    </div>
                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleImportModal}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i>
                        <span className="ms-2">{t("import")}</span>
                      </button>

                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleExport}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i>
                        <span className="ms-2">{t("export")}</span>
                      </button>
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleAddModal}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "10%" }}
                            >
                              {t("name")}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "10%" }}
                            >
                              {t("email")}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "10%" }}
                            >
                              {t("phone_number")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "10%" }}
                            >
                              {t("vat_number")}{" "}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {clientProfileListe?.map((item, index) => {
                            return (
                              <>
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.email}</td>
                                  <td>{item.phone_number}</td>
                                  <td>{item.vat_number}</td>

                                  <td className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          // This logic runs when the dropdown is opened
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive"
                                            );
                                          if (window.innerWidth <= 767) {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "auto !important";
                                              tableResponsive.style.overflowY =
                                                "auto !important";
                                            }
                                          } else {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "inherit !important";
                                              tableResponsive.style.overflowY =
                                                "inherit !important";
                                            }
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onEditPartGroup(e, item)
                                          }
                                        >
                                          <div className="edit-btn">
                                            <i className="bi bi-pencil"></i>
                                          </div>

                                          <span>{t("edit")}</span>
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onDeleteModalOpen(e, item)
                                          }
                                        >
                                          <div className="trash-btn delete-btn">
                                            <i className="bi bi-trash3"></i>
                                          </div>

                                          <span>{t("delete")}</span>
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                        {clientProfileListe &&
                          clientProfileListe?.length === 0 && (
                            <tr>
                              <td colSpan={7} className={`text-center`}>
                                {" "}
                                {t("no_record_found")}
                              </td>
                            </tr>
                          )}
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer clearfix card-footer-part ">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_client")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("are_you_sure_you_want_to_delete_this_client")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartType}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal} size="lg">
        <ModalHeader>{t("client_profile")}</ModalHeader>
        <Form method={`post`} onSubmit={handleWarehoueEntity}>
          <ModalBody>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.name}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder={t("name")}
                      />
                      {errors.name && (
                        <span className="input-error">{errors.name}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            country_code: e.target.value,
                          });
                        }}
                        name={`country_code`}
                        maxLength={50}
                        placeholder={t("country_code")}
                      />
                      {errors.country_code && (
                        <span className="input-error">
                          {errors.country_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={countryList}
                        value={countryList.find(
                          (option) =>
                            option.value ===
                            Number(clientProfileData.country_id)
                        )}
                        onChange={(selectedOption) => {
                          const selectedCountryId = selectedOption ? selectedOption.value : "";

                          setclientProfileData({
                            ...clientProfileData,
                            country_id: selectedCountryId,
                            district: "",
                            city: "",
                          });

                          if (!selectedOption) {
                            setStateList([]);
                            setCityList([]);
                          }
                        }}

                        isClearable
                        isSearchable
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("state")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={stateList}
                        value={stateList.find(
                          (option) =>
                            option.value === Number(clientProfileData.district)
                        )}
                        onChange={(selectedOption) => {
                          const selectedStateId = selectedOption ? selectedOption.value : "";

                          setclientProfileData({
                            ...clientProfileData,
                            district: selectedStateId,
                            city: "",
                          });

                          if (!selectedOption) {
                            setCityList([]);
                          }
                        }}

                        isDisabled={!clientProfileData.country_id}
                        isClearable
                        isSearchable
                      />
                      {errors.district && (
                        <span className="input-error">{errors.district}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={cityList}
                        value={cityList.find(
                          (option) =>
                            option.value === Number(clientProfileData.city)
                        )}
                        onChange={(selectedOption) => {
                          setclientProfileData({
                            ...clientProfileData,
                            city: selectedOption.value
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isDisabled={!clientProfileData.district}
                        isClearable
                        isSearchable
                      />
                      {errors.city && (
                        <span className="input-error">{errors.city}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("bill_address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.bill_address}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            bill_address: e.target.value,
                          });
                        }}
                        name={`bill_address`}
                        maxLength={50}
                        placeholder={t("bill_address")}
                      />

                      {errors.bill_address && (
                        <span className="input-error">
                          {errors.bill_address}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("postal_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.postal_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            postal_code: e.target.value,
                          });
                        }}
                        name={`postal_code`}
                        maxLength={50}
                        placeholder={t("postal_code")}
                      />

                      {errors.postal_code && (
                        <span className="input-error">
                          {errors.postal_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_country_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_country_code: e.target.value,
                          });
                        }}
                        name={`vat_country_code`}
                        maxLength={50}
                        placeholder={t("vat_country_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_number: e.target.value,
                          });
                        }}
                        name={`vat_number`}
                        maxLength={50}
                        placeholder={t("vat_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_percentages")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_percentage ?? 23}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_percentage: e.target.value,
                          });
                        }}
                        name="vat_percentage"
                        maxLength={50}
                        placeholder={t("vat_percentages")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("is_VAT_exempt")}{" "}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={clientProfileData?.is_vat_exempt === 1}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label pl-2">
                          VAT exempt{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("indicative_phone_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={
                          clientProfileData.indicative_phone_code || "+351"
                        }
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            indicative_phone_code: e.target.value,
                          });
                        }}
                        name={`indicative_phone_code`}
                        maxLength={50}
                        placeholder={t("indicative_phone_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.phone_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            phone_number: e.target.value,
                          });
                        }}
                        name={`phone_number`}
                        maxLength={50}
                        placeholder={t("phone_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("whatsapp_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.whatsapp_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            whatsapp_number: e.target.value,
                          });
                        }}
                        name={`whatsapp_number`}
                        maxLength={50}
                        placeholder={t("whatsapp_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.email}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder={t("email")}
                      />
                      {errors.email && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4"></div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("shipping_address")}
                  </Label>
                  <div className="col-xl-12">
                    {clientProfileData?.shipping_addresses?.map(
                      (address, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-2"
                        >
                          <input
                            type="text"
                            className="form-control input-search mr-2"
                            placeholder={`Shipping address ${index + 1}`}
                            value={address}
                            onChange={(e) =>
                              handleAddressChange(index, e.target.value)
                            } // Update address
                          />
                          <i
                            className="bi bi-x-circle"
                            style={{
                              marginTop: "-41px",
                              marginLeft: "-16px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveAddress(index)} // Remove address
                          ></i>
                        </div>
                      )
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={handleAddAddress} // Add address
                    >
                      ➕ {t("add_address")}
                    </button>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyImportModal}>
        <Form method={`post`} onSubmit={handleImportGroup}>
          <ModalHeader>{t("import_client_file")}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label">{t("select_file")}</Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control"
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        name="file"
                        accept=".csv,.xlsx"
                      />
                    </div>
                    {errorsImport.file && (
                      <span className="input-error">{errorsImport.file}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              disabled={isModifyButtonLoad}
              onClick={handleImportCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")}
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("import")}
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ClientProfile;
